import Constants from '@/Constants';
import { FollowersBatchRequest } from '@/models/FollowersBatchRequest';
import { FollowersRequest } from '@/models/FollowersRequest';
import http from '@/services/HttpService';
import { call, put, select } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import { ApplicationState } from '..';
import {
    batchFollowFailure,
    batchFollowSuccess,
    clearFollowers,
    clearFollowing,
    decreaseFollowing,
    deleteFollowerFailure,
    deleteFollowerSuccess,
    getFollowersFailure,
    getFollowersSuccess,
    getFollowingFailure,
    getFollowingSuccess,
    increaseFollowing,
    setFollowerFailure,
    setFollowerSuccess,
} from './action';
import { FollowerTypes } from './types';

function* requestFollowers(personId: number, offset: number = 0, limit: number = Constants.FOLLOWERS_LIMIT) {
    try {
        const path = Constants.CAST_FOLLOW_URI.replace('%p', `${personId}`);
        const queryParams = `?offset=${offset}&limit=${limit}`;

        const { data, headers } = yield call(http.get, path + queryParams);

        yield put(getFollowersSuccess(data, parseInt(headers.total, 10)));
    } catch (error) {
        yield put(getFollowersFailure(error));
    }
}

function* requestFollowing(personId: number, offset: number = 0, limit: number = Constants.FOLLOWERS_LIMIT) {
    try {
        const path = Constants.CAST_FOLLOWING_URI.replace('%p', `${personId}`);
        const queryParams = `?offset=${offset}&limit=${limit}`;

        const { data, headers } = yield call(http.get, path + queryParams);

        yield put(getFollowingSuccess(data, parseInt(headers.total, 10)));
    } catch (error) {
        yield put(getFollowingFailure(error));
    }
}

export function* getFollowersRequest(action: PayloadAction<FollowerTypes.GET_FOLLOWERS_REQUEST, FollowersRequest>) {
    const { personId, pagination } = action.payload;
    yield call(requestFollowers, personId, pagination.offset, pagination.limit);
}

export function* setFollowerRequest(action: PayloadAction<FollowerTypes.SET_FOLLOWER_REQUEST, { personId: number; isLoggedUserProfile: boolean }>) {
    try {
        const { id: myPersonId } = yield select((state: ApplicationState) => state.identity.data.person);
        const { personId, isLoggedUserProfile } = action.payload;

        yield call(http.post, Constants.SOCIAL_FOLLOW_URI.replace('%p', myPersonId.toString()), {
            personId,
        });

        yield put(setFollowerSuccess());
        yield put(increaseFollowing(isLoggedUserProfile));
    } catch (error) {
        yield put(setFollowerFailure(error));
    }
}

export function* deleteFollowerRequest(
    action: PayloadAction<FollowerTypes.DELETE_FOLLOWER_REQUEST, { personId: number; isLoggedUserProfile: boolean }>,
) {
    try {
        const { id: myPersonId } = yield select((state: ApplicationState) => state.identity.data.person);
        const { personId, isLoggedUserProfile } = action.payload;

        yield call(http.delete, Constants.SOCIAL_UNFOLLOW_URI.replace('%p', myPersonId.toString()).replace('%c', personId.toString()));

        yield put(deleteFollowerSuccess());
        yield put(decreaseFollowing(isLoggedUserProfile));
    } catch (error) {
        yield put(deleteFollowerFailure(error));
    }
}

export function* getFollowingRequest(action: PayloadAction<FollowerTypes.GET_FOLLOWING_REQUEST, FollowersRequest>) {
    const { personId, pagination } = action.payload;
    yield call(requestFollowing, personId, pagination.offset, pagination.limit);
}

export function* updateFollowBatchRequest(action: PayloadAction<FollowerTypes.BATCH_FOLLOW_REQUEST, FollowersBatchRequest>) {
    try {
        const { personId, listOfPerson } = action.payload;
        if (listOfPerson.length > 0) {
            yield call(http.post, Constants.SOCIAL_BATCH_FOLLOW_URI.replace('%p', String(personId)), listOfPerson);
            yield put(batchFollowSuccess());

            yield put(clearFollowers());
            yield put(clearFollowing());

            const { currentPersonId } = yield select((state: ApplicationState) => ({ currentPersonId: state.people.publicPerson?.id }));

            yield call(requestFollowers, currentPersonId);
            yield call(requestFollowing, currentPersonId);
        }
    } catch (error) {
        yield put(batchFollowFailure(error));
    }
}
